/* @ts-ignore */
import * as React from 'react';
import { Form, Input, AutoComplete, Upload, Icon } from 'antd';
import { Button } from '@ui/components';
import { transformFormatSource } from '@ui/tools/transformSource';

import './createCollectionForm.less';

const { Item } = Form;

export default Form.create({
  name: 'form_in_modal',
  onValuesChange: (props: any, changedValues: any) =>
    props.onChangeFields(changedValues),
})(
  // @ts-ignore
  class extends React.Component {
    render() {
      const {
        // @ts-ignore
        onCreate,
        // @ts-ignore
        form: { getFieldDecorator },
        // @ts-ignore
        countries,
        // @ts-ignore
        file,
      } = this.props;

      const countriesSource = transformFormatSource(countries);

      return (
        <Form onSubmit={onCreate} className="create-collection-form">
          <div className="create-collection-form__body">
            <Item
              label="IdLotus"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
              }}
            >
              {getFieldDecorator('idLotus', {})(
                <Input size="large" className="input-id-lotus" />,
              )}
            </Item>

            <Item label="Название">
              {getFieldDecorator('name', {
                rules: [
                  { required: true, message: 'вы должны заполнить поле' },
                ],
              })(<Input size="large" />)}
            </Item>

            <Item label="артикул">
              {getFieldDecorator('vendorCode', {
                rules: [
                  { required: true, message: 'вы должны заполнить поле' },
                ],
              })(<Input size="large" />)}
            </Item>

            <Item label="страна">
              {getFieldDecorator('country', {
                rules: [
                  { required: true, message: 'вы должны заполнить поле' },
                ],
              })(
                <AutoComplete dataSource={countriesSource} size="large">
                  <Input size="large" />
                </AutoComplete>,
              )}
            </Item>

            <Item>
              {getFieldDecorator('file', {
                rules: [
                  { required: false, message: 'вы должны заполнить поле' },
                ],
              })(
                <Upload
                  beforeUpload={() => false}
                  name={'photo-store'}
                  fileList={file ? [file.file] : []}
                >
                  <div style={{ paddingTop: '16px' }}>
                    <Button
                      type="primary"
                      size="large"
                      className="upload-store-photo"
                    >
                      <Icon type="camera" /> загрузить фото
                    </Button>
                  </div>
                </Upload>,
              )}
            </Item>
          </div>

          <Item style={{ paddingTop: '16px' }}>
            <Item style={{ padding: '16px' }}>
              <Button htmlType="submit" className="button-create-store">
                Сохранить
              </Button>
            </Item>
          </Item>
        </Form>
      );
    }
  },
);



// WEBPACK FOOTER //
// ./src/scenes/Collections/components/CreateCollectionForm/CreateCollectionForm.tsx